import * as React from 'react';

import BaseReportingPage from '../base/BaseReportingPage';
import CampaignReportSummary from '../../components/campaign-report-summary/CampaignReportSummary';

import { __t, applyTranslations } from 'utils/language';

import type { Params } from 'types';

applyTranslations(require('./summary-page.i18n.json'));

type Props = {
  params: Params
};

const SummaryPage = (
  {
    params
  }: Props
): JSX.Element => (
  <BaseReportingPage
    headline={__t('summary_report_page.title')}
    params={params}
  >
    <CampaignReportSummary />
  </BaseReportingPage>
);

export default SummaryPage;
